// ============================================================================
// Versión del BACKEND (package.json de seguridad_backend), expuesta por el
// endpoint público `GET /api/version` (mismo contrato de payload que
// back_autohub; la ruta va bajo `/api` porque aquí el reverse proxy solo
// reenvía `/api/*` al backend — el resto cae en el fallback estático SPA).
//
// Degradación silenciosa: devuelve `null` si el endpoint no responde (backend
// viejo aún sin desplegar, red caída, CORS). El consumidor (pie del sidebar)
// simplemente omite la línea del backend en ese caso, sin romper el render.
// ============================================================================
import { httpClient } from "./httpClient";

export const getBackendVersion = async (): Promise<string | null> => {
  try {
    const { data } = await httpClient.get("api/version");
    return data?.version ?? null;
  } catch {
    return null;
  }
};
